import React from 'react';
import styles from './toolbarButton.module.scss';
import cx from 'classnames';
import { Image, Tooltip, OverlayTrigger } from 'react-bootstrap';


export class ToolBarButtonItem  extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    let buttonStyle ={
      width: this.props.width,
      height: this.props.height,
    }

    return(
      <div className={cx(
        styles.button,
        this.props.className,
        {[styles.disabled]: this.props.disabled})}
        onClick={this.handleClick}>
        <div className={styles.icon}>
          <div className={styles.inner} style={buttonStyle}>
            {this._wrapToolTipComponent(this._renderChildren())}
          </div>
        </div>
      </div>
    );
  }

  _renderChildren(){
    let children = Array();

    if(this.props.icon || this.props.title){

      if(this.props.icon){
        children.push(<Image src={this.props.icon} key="icon"/>);
      }

      if(this.props.title){
        children.push(<span className={styles.title} key="title">{this.props.title}</span>);
      }

      return children;
    }else{
      return this.props.children;
    }
  }

  _wrapToolTipComponent(component){
    if(!this.props.tooltip){
        return component;
    }

    let tooltip = <Tooltip>{this.props.tooltip}</Tooltip>
    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <div>{component}</div>
      </OverlayTrigger>
    );
  }

  handleClick(){
    if(this.props.onClick && !this.props.disabled){
      this.props.onClick();
    }
  }
}

ToolBarButtonItem.defaultProps = {width: 40, height: 40}